import { Operation, Partner, Society } from 'types';
import { getDecimalScale, getSocietyValue } from 'utils/filters';

import { operationsPartnerBook } from 'modules/transactions/constants/operationsPartnerBook';
import { getPartnersPercentages } from './getPartnersPercentages';
import { getHistoryTransactions } from './getHistoryTransactions';
import { getSharesByPartner } from './getSharesByPartner';

type BuildPartnersRegisterProps = {
  partners: Partner[];
  actualSociety: Society;
  operations: Operation[];
  holdingClassNames: { [key: string]: string };
};

export const buildPartnersRegister = async ({
  partners,
  operations,
  actualSociety,
  holdingClassNames,
}: BuildPartnersRegisterProps) => {
  if (!actualSociety) return;
  if (!operations?.length || !partners?.length) return;

  const societyId = actualSociety._id;

  try {
    const currentOperations = operations.filter((op) =>
      operationsPartnerBook.includes(op.operationType)
    );

    const activePartners = partners?.filter(
      (partner) => partner?.sharesCount?.actual > 0
    );

    const societyValue = getSocietyValue(actualSociety);
    const decimalScale = societyValue
      ? getDecimalScale((societyValue as any).value)
      : 2;

    const percentages = getPartnersPercentages(
      activePartners,
      actualSociety?.sharesCount?.actual || 0,
      decimalScale
    );

    const partnerIds = activePartners.map((partner) => partner['_id']);

    const sharesByPartner = await getSharesByPartner(
      partnerIds,
      societyId || ''
    );

    const partnersData = activePartners.reduce((acc: any, partner: any) => {
      acc[partner['_id']] = {
        percentage: percentages[partner['_id']],
        history: getHistoryTransactions({
          partnerId: partner['_id'],
          operations: currentOperations,
          holdingClassNames,
        }),
        shares: sharesByPartner?.[partner._id]?.sort(
          (a: any, b: any) => a.from - b.from
        ),
      };
      return acc;
    }, {});

    return partnersData;
  } catch (error) {
    return undefined;
  }
};
